/**
 * Application Configuration
 * Values are loaded from environment variables (.env file)
 */

export const config = {
  /**
   * API base URL for the Quran Radio backend
   * If not set, will use the current host
   */
  apiUrl: import.meta.env.VITE_API_URL || null,

  /**
   * API endpoints (relative to apiUrl or current host)
   */
  endpoints: {
    channels: import.meta.env.VITE_CHANNELS_ENDPOINT || '/api/channels',
  },

  /**
   * Polling interval in milliseconds for channel updates
   */
  pollInterval: parseInt(import.meta.env.VITE_POLL_INTERVAL || '30000', 10),

  /**
   * Get the full API URL for an endpoint
   */
  getApiUrl(endpoint: string): string {
    if (this.apiUrl) {
      return `${this.apiUrl}${endpoint}`
    }

    // Construct URL from current page location
    const protocol = window.location.protocol
    const host = window.location.host
    return `${protocol}//${host}${endpoint}`
  },

  /**
   * Get channels API URL
   */
  getChannelsUrl(): string {
    return this.getApiUrl(this.endpoints.channels)
  },
}
